const focusableElements = [
	"input",
	"select",
	"textarea",
	"button",
	"a"
];

function isFocusableElement(element) {
	return focusableElements.indexOf(element.tagName.toLowerCase()) > -1;
}

module.exports = {
	isFocusableElement
};